import CategoryRepository from '../../repositories/CategoryRepository'

const state = {
  categories: [],
  category: {},
  error: '',
  categoriesDetail: [],
}

const getters = {
}

const actions = {
  async get({ commit }) {
    await CategoryRepository.get()
      .then(resp => {
        commit('setCategories', resp.data.data)
      })
  },
  async detail({ commit }, id){
    await CategoryRepository.detail(id)
      .then(resp => {
        commit('setCategory', resp.data.data)
      })
  },
  async put({ commit, dispatch }, payload){
    await CategoryRepository.put(payload)
      .then(() => {
        commit('setError', '')
        dispatch('get')
      })
  },
  async post({ commit, dispatch }, payload){
    await CategoryRepository.post(payload)
      .then(() => {
        commit('setError', '')
        dispatch('get')
      }).catch(error => {
        commit('setError', error.response.data.message)
      })
  },
  async delete({ commit, dispatch }, id){
    await CategoryRepository.delete(id)
      .then(() => {
        commit('setError', '')
        dispatch('get')
      })
  },
  async getDetail({ commit }) {
    await CategoryRepository.getDetail()
      .then(resp => {
        commit('setCategoriesDetail', resp.data.data)
      })
  },
  setError({ commit }){
    commit('setError', '')
  },
}

const mutations = {
  setCategories (state, data) {
    state.categories = data
  },
  setCategory (state, data) {
    state.category = data
  },
  setCategoriesDetail (state, data) {
    state.categoriesDetail = data
  },
  setError(state, msg){
    state.error = msg
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
